module.exports = __webpack_public_path__ + "img/introduction2.87988f05.png";